var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconListOutput48Line = function SvgIconListOutput48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 17.771h3.1v4.46h3.4v-6.16c0-.11-.01-.21-.03-.32v-.02c-.03-.14-.08-.27-.15-.4-.02-.04-.04-.07-.06-.11a1.67 1.67 0 0 0-.26-.35l-6-6.01c-.11-.11-.23-.19-.35-.27a.313.313 0 0 0-.1-.05c-.23-.11-.48-.18-.75-.18H16.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h7.63v-3.4H16.6a1.9 1.9 0 0 1-1.9-1.9v-18.78c0-1.05.85-1.9 1.9-1.9h10.7v3.1c0 1.6 1.3 2.9 2.9 2.9v-.01Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41.17 30.901-5.79-5.51-2.35 2.46 3.62 3.45h-8.73v3.4h8.73l-3.62 3.45 2.35 2.46 5.78-5.51c.57-.54.9-1.31.9-2.1s-.33-1.56-.9-2.1h.01Z",
    fill: "current"
  })));
};
export default SvgIconListOutput48Line;